import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useSEO } from "@/hooks/useSEO";

export default function AdminLogin() {
  useSEO({ title: "Area riservata — JetSeat", noindex: true });
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-midnight text-white flex items-center justify-center px-6 grain" data-testid="admin-login-page">
      <div className="relative z-10 w-full max-w-md">
        <Logo dark />
        <h1 className="mt-10 font-serif text-4xl tracking-tight">Area riservata</h1>
        <p className="mt-2 text-white/50 text-sm">Accedi per gestire lead e partnership.</p>
        <form onSubmit={submit} className="mt-10 space-y-7" data-testid="admin-login-form">
          <div className="flex flex-col gap-2">
            <Label className="overline text-white/50">Email</Label>
            <Input type="email" required data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="rounded-none border-0 border-b border-white/20 bg-transparent px-0 text-white focus-visible:ring-0 focus-visible:border-gold" />
          </div>
          <div className="flex flex-col gap-2">
            <Label className="overline text-white/50">Password</Label>
            <Input type="password" required data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="rounded-none border-0 border-b border-white/20 bg-transparent px-0 text-white focus-visible:ring-0 focus-visible:border-gold" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full rounded-full bg-gold py-4 text-sm font-semibold uppercase tracking-[0.14em] text-midnight transition-transform duration-300 hover:scale-[1.02] disabled:opacity-60">
            {loading ? "…" : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
